import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { useCounterpartyByIdQuery } from "@api/counterparty.api";
import { CounterpartyEditorDrawer } from "@components/settings/Directory/CounterpartyEditor/CounterpartyEditorDrawer";

interface Props {
    show: boolean;
    onClose: () => void;
    counterpartyId: string;
    onCounterpartyUpdated: (counterparty: Counterparty) => void;
}

export const InvoiceEditCounterpartyModal: React.FC<Props> = ({
    show,
    onClose,
    counterpartyId,
    onCounterpartyUpdated,
}) => {
    const counterpartyQuery = useCounterpartyByIdQuery({
        counterpartyId,
        enabled: show,
    });
    const counterparty = counterpartyQuery.data;

    const handleEdited = (updatedCounterparty: Counterparty) => {
        onCounterpartyUpdated(updatedCounterparty);
        onClose();
    };

    return (
        <CounterpartyEditorDrawer
            open={show && Boolean(counterparty)}
            isCreating={false}
            counterparty={counterparty}
            onClose={onClose}
            onCreated={() => undefined}
            onEdited={handleEdited}
            onLocalized={onCounterpartyUpdated}
        />
    );
};
